import { render, staticRenderFns } from "./notificationForm.vue?vue&type=template&id=2584fea6&scoped=true&"
import script from "./notificationForm.vue?vue&type=script&lang=js&"
export * from "./notificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584fea6",
  null
  
)

export default component.exports